(function (angular) {
    'use strict';

    angular.module('reports')
        /**
         * Service to convert service data into chart data
         */
        .factory('historicChatReportingService', ["channelsProvider", function (channelsProvider) {

            var _channelIdLookup = {
                "sms": "SMS",
                "fbMessenger": "Messenger",
                "twitterDm": "Twitter",
                "appMessaging": "App Messaging",
                "email": "Email",
                "whatsApp": "WhatsApp",
                "rcs": "RCS"
            }

            //removing channels that aren't allowed to be displayed
            for(var channelId in channelsProvider){
                if(!channelsProvider[channelId].allowed){
                    delete _channelIdLookup[channelId];
                }
            }

            /**
             * 
             * @param {*} data 
             */
            function buildOpenClosedOverTimeData(data) {
                // x axis will be the dates 
                // 2 datasets - open & closed ...

                var datasets = [];
                var openData = {
                    label: "opened",
                    data: [],
                    backgroundColor: "#37A2FF",
                    borderColor: "#37A2FF",
                    fill: false,
                };
                var closedData = {
                    label: "closed",
                    data: [],
                    backgroundColor: "#39A60C",
                    borderColor: "#39A60C",
                    fill: false,
                };
                datasets.push(openData);
                datasets.push(closedData);

                if (data) {

                    // we have grouped by agent so for a given time block, there will be multiple records
                    // need to amalgumate these for this graph (and sum the data)
                    // will adopt a 2 pass approach 
                    /*
                    {
                        date: [{
                            opened: 0,
                            closed: 3
                        }]
                    }
                    *
                    */

                    var amalgum = {};

                    data.forEach(function (item) {

                        if (!amalgum[item.date]) {
                            amalgum[item.date] = [];
                        }

                        var opened = item.assigned ? (item.assigned - item.reassigned) : 0;
                        var closed = item.closed || 0;

                        amalgum[item.date].push({
                            opened: opened,
                            closed: closed
                        });

                    });

                    for (var date in amalgum) {
                        var items = amalgum[date];

                        var openedSum = 0;
                        var closedSum = 0;
                        items.forEach(function (item) {
                            openedSum += item.opened;
                            closedSum += item.closed;
                        });
                        openData.data.push({ x: moment(date), y: openedSum });
                        closedData.data.push({ x: moment(date), y: closedSum });

                    }
                }

                return {
                    datasets: datasets
                }
            }

            /**
             * 
             * @param {*} currentTeam 
             * @param {*} data 
             */
            function buildChannelBreakdownData(currentTeam, data) {

                var labels = [];
                var colors = [];
                var pieData = [];

                if (data) {

                    var channelSpread = {};

                    data.forEach(function (item) {
                        if (item.initialChannel) {
                            for (var channelName in item.initialChannel) {

                                var count = item.initialChannel[channelName];

                                if (channelSpread[channelName]) {
                                    channelSpread[channelName] += count;
                                } else {
                                    channelSpread[channelName] = count;
                                }
                            }
                        }
                    });

                    var labelColors = {
                        sms: "#12f990",
                        fbMessenger: "#01b8ff",
                        twitterDm: "#1da1f2",
                        appMessaging: "#865cd6",
                        email: "#fabb49",
                        whatsApp: "#25D366",
                        rcs: "#333333"
                    }

                    for (var channelName in currentTeam.channels) {
                        labels.push(_channelIdLookup[channelName]);
                        colors.push(labelColors[channelName]);
                        pieData.push(channelSpread[channelName] || 0);
                    }
                }

                return {
                    labels: labels,
                    colors: colors,
                    data: pieData
                }

            }

            /**
             * 
             * @param {*} name 
             */
            function getAgentAvatar(users, agentName) {

                var user = users.find(function (u) {
                    return u.userName === agentName;
                });

                return (user && user.avatarUrl) || "assets/img/avatar.svg";
            }

            /**
             * 
             * @param {*} name 
             */
            function getAgentFirstName(users, agentName) {

                var user = users.find(function (u) {
                    return u.userName === agentName;
                });

                return (user && user.firstName) || agentName;
            }
            /**
             * 
             * @param {*} data 
             */
            function buildAgentBreakdownData(users, data) {
                // iterate over the records and sort into buckets based on agentId

                var agents = {};

                data.forEach(function (item) {

                    if (item.agentId) {

                        var agent = item.agentId.replace("PLATFORMUSER\\", "");

                        if (!agents[agent]) {
                            agents[agent] = [];
                        }

                        var opened = item.assigned ? (item.assigned - item.reassigned) : 0;
                        var closed = item.closed || 0;
                        var responses = item.responses || 0;

                        agents[agent].push({
                            opened: opened,
                            closed: closed,
                            timeToRespondSeconds: item.timeToRespondSeconds,
                            timeToCloseSeconds: item.timeToCloseSeconds,
                            responses: responses,
                        });

                    }
                });

                var rows = [];

                var allOpenedSum = 0;
                var allClosedSum = 0;

                var allAvgResSum = 0;
                var allAvgResCnt = 0;

                var allAvgCloseSum = 0;
                var allAvgCloseCnt = 0;

                for (var agentName in agents) {

                    var stats = agents[agentName];

                    var openedSum = 0;
                    var closedSum = 0;

                    var avgResSum = 0;
                    var avgResCnt = 0;

                    var avgCloseSum = 0;
                    var avgCloseCnt = 0;

                    stats.forEach(function (stat) {
                        openedSum += stat.opened || 0;
                        closedSum += stat.closed || 0;

                        if (stat.timeToRespondSeconds) {
                            avgResSum += stat.timeToRespondSeconds;
                            avgResCnt += stat.responses || 1;

                            allAvgResSum += stat.timeToRespondSeconds;
                            allAvgResCnt += stat.responses || 1;
                        }

                        if (stat.timeToCloseSeconds) {
                            avgCloseSum += stat.timeToCloseSeconds;
                            avgCloseCnt += stat.closed || 1;

                            allAvgCloseSum += stat.timeToCloseSeconds;
                            allAvgCloseCnt += stat.closed || 1;
                        }
                    });

                    allOpenedSum += openedSum;
                    allClosedSum += closedSum;

                    var row = {
                        name: getAgentFirstName(users, agentName),
                        avatar: getAgentAvatar(users, agentName),
                        opened: openedSum,
                        closed: closedSum,
                        avgResTime: avgResSum ? Math.floor(avgResSum / avgResCnt) : 0,
                        avgCloseTime: avgCloseSum ? Math.floor(avgCloseSum / avgCloseCnt) : 0
                    }

                    rows.push(row);
                }

                rows.push({
                    name: "All",
                    opened: allOpenedSum,
                    closed: allClosedSum,
                    avgResTime: allAvgResSum ? Math.floor(allAvgResSum / allAvgResCnt) : 0,
                    avgCloseTime: allAvgCloseSum ? Math.floor(allAvgCloseSum / allAvgCloseCnt) : 0
                });

                return rows;
            }

            var fac = {
                buildAgentBreakdownData: buildAgentBreakdownData,
                buildChannelBreakdownData: buildChannelBreakdownData,
                buildOpenClosedOverTimeData: buildOpenClosedOverTimeData
            };

            return fac;

        }]);
})(window.angular);